module.exports = __webpack_public_path__ + "static/media/xmark.01fc3c8d.svg";